module.exports = __webpack_public_path__ + "img/icon-app-store.5addee84.svg";